import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/mom/work-order/{id}/approve`。body 僅 `updatedAt`。 */
export async function approveWorkOrder(id, payload = {}) {
  const { data: raw } = await request.post(
    `/mom/work-order/${id}/approve`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
